<template>
  <div>
    <div>商品选择器;</div>
    <div class="margin_container">
      <el-button @click="selectGoods">
点击选择商品
</el-button>
      <div
        v-for="(item, index) in goodsData.list"
        :key="index"
        class="margin_box"
      >
        <el-input
          v-model="margin[index]"
          width="32px"
          :data-index="index"
        />
        <div class="margin_box_text">
          {{ margin_index[index] }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import mixin from '@/view/weappTmp/core/lib/package/element-node-mixin.js'
// import src/components/goodsSelect/index.vue
export default {
  name: 'GoodsPicker',
  mixins: [mixin],
  data () {
    return {
      goodsData: {
        url:'',
        list:[]
      },
    }
  },
  watch: {},
  created () {},
  methods: {
    selectGoods (){
      this.$emit('PickerChange',{type:'selectGoods',data:this.goodsData})
    }
  }
}
</script>
<style scoped lang="scss">
.margin_container {
  display: flex;
}
.margin_box {
  margin-right: 8px;
  text-align: center;
  .margin_box_text {
    margin-top: 4px;
  }
}
</style>
